import { render, staticRenderFns } from "./BlockMenu.vue?vue&type=template&id=5af45548&scoped=true&"
import script from "./BlockMenu.vue?vue&type=script&lang=js&"
export * from "./BlockMenu.vue?vue&type=script&lang=js&"
import style0 from "./BlockMenu.vue?vue&type=style&index=0&id=5af45548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af45548",
  null
  
)

export default component.exports